import { MAKE_A_REQUEST_SCREEN_ID } from '@buxus/shared'
import { pathForAppState, type OperatorUrlSlugResolver } from '../../navigation/appPaths'

export { MAKE_A_REQUEST_SCREEN_ID }

export const MAKE_A_REQUEST_STACK = [
  'screen.operatorOverview',
  MAKE_A_REQUEST_SCREEN_ID,
] as const

export function makeARequestHubPath(
  operatorId: string,
  urlSlugForOperator?: OperatorUrlSlugResolver,
): string {
  return pathForAppState(operatorId, [...MAKE_A_REQUEST_STACK], urlSlugForOperator)
}
